<template>
  <div>
    <v-data-table
      :loading="loading"
      :items="items"
      :headers="headers"
      class="elevation-1"
      disable-pagination
      hide-default-footer
    >
      <template v-slot:[`item.amount`]="{ item }">
        {{ item.price.amount | priceSplitter }}
      </template>
      <template v-slot:[`item.currency`]="{ item }">
        {{ item.price.currency }}
      </template>
      <template v-slot:[`item.youNeedCount`]="{ item }">
        <v-text-field
          class="mt-3 mb-n2"
          dense
          outlined
          :rules="[
            (v) => {
              if (v > item.maxAmount && item.maxAmount > 0) {
                return (
                  'تعداد مورد نظر باید کوچکتر از ' + item.maxAmount + 'باشد.'
                );
              } else return true;
            },
          ]"
          required
          @input="checkInput(item)"
          clearable
          type="number"
          label=" تعداد مورد نظر"
          v-model="item.youNeedCount"
          placeholder="صفحه کلید به انگلیسی باشد"
        >
        </v-text-field>
      </template>
      <template v-slot:[`item.totalOfRow`]="{ item }">
        {{ (item.price.amount * item.youNeedCount) | priceSplitter }}
      </template>
    </v-data-table>
    <v-card outlined class="mt-3" v-if="TotalAmount">
      <v-card-text>
        <div class="d-flex flex-row justify-content-between">
          <h4 for="">جمع کل (مبلغ قابل شارژ)</h4>
          <h3>{{ TotalAmount | priceSplitter }} ریال</h3>
          <v-btn color="primary " @click="goToWallet()">شارژ کیف پول</v-btn>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { RepoFactory } from '@/baseRepository/Factory';
const servicePricesRepository = RepoFactory.get('servicePrices');
import Helper from '@/core/helpers';
import Swal from 'sweetalert2';
export default {
  props: {
    categoryType: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      loading: false,
      items: [],
      headers: [
        { sortable: true, text: 'عنوان هزینه', value: 'title' },
        { sortable: true, text: 'مبلغ واحد ', value: 'amount' },
        { sortable: true, text: 'پول', value: 'currency' },
        { sortable: true, text: 'تعداد مورد نظر', value: 'youNeedCount' },
        {
          sortable: true,
          text: 'مبلغ مورد نیاز',
          value: 'totalOfRow',
        },
      ],
    };
  },
  computed: {
    subscriptionBaseUrl() {
      return this.$store.getters.subscriptionBaseUrl;
    },
    TotalAmount() {
      let total = 0;
      this.items.forEach((item) => {
        total = total + item.price.amount * item.youNeedCount;
      });
      return total;
    },
  },
  created() {
    this.getServicePrices();
  },
  watch: {
    subscriptionBaseUrl() {
      return this.$store.getters.subscriptionBaseUrl;
    },
  },
  methods: {
    goToWallet() {
      this.$router.replace({
        path: '/financial-management/wallet',
        query: {
          showWalletForm: true,
          amount: this.TotalAmount,
        },
      });
    },
    checkInput(item) {
      if (item.maxAmount > 0 && item.youNeedCount > item.maxAmount) {
        Swal.fire({
          icon: 'error',
          title: 'خطا',
          text: 'تعداد مورد نظر باید کوچکتر از ' + item.maxAmount + 'باشد.',
          confirmButtonText: ' بستن',
        });
        item.youNeedCount = item.maxAmount;
      }
    },
    getServicePrices() {
      const loader = this.$loading.show();
      this.loading = true;
      servicePricesRepository
        .getServicePrices(this.subscriptionBaseUrl)
        .then((res) => {
          this.items = [];
          res.data.forEach((element) => {
            this.items.push({
              ...element,
              youNeedCount: null,
            });
          });
        })
        .catch((error) => {
          Helper.handleErrors(error, this);
        })
        .finally(() => {
          this.loading = false;
          loader.hide();
        });
    },
  },
};
</script>

<style scoped></style>
